import React, { useCallback, useEffect, useState } from 'react'
import InfiniteScrollSelect from '../../../components/InfiniteScrollSelect/InfiniteScrollSelect'
import { useDispatch, useSelector } from 'react-redux'
import { debounce } from 'lodash'
import { Avatar, Image, Row, Space } from 'antd'
import UserReportDrawerDateFilter from '../filters/userReportDrawerDateFilter'
import { getProjectByUserId, setDrawerFilter } from '../store/finalReports.slice'
import { CrossIcon } from '../../../assets/icons'

const UserReportsDrawerFilter = ({ user }) => {
    const dispatch = useDispatch()
    const [searchValue, setSearchValue] = useState('')
    const [filteredProjects, setFilteredProjects] = useState([])
    const [selectedProjects, setSelectedProjects] = useState([])
    const [hasFetched, setHasFetched] = useState(false)

    const { reportDrawerFilterData } = useSelector((state) => state.finalReportsSlice)
    const fetchProjects = async () => {
        if (hasFetched || !user?._id) return

        try {
            const res = await dispatch(getProjectByUserId(user._id)).unwrap()

            const formatted = (res?.data || []).map((project) => ({
                label: project.name,
                value: project._id,
                projectProfile: project.projectProfile,
            }))

            setFilteredProjects(formatted)
            setHasFetched(true)
        } catch (error) {
            console.error('Error fetching user projects:', error)
        }
    }

    useEffect(() => {
        if (!filteredProjects.length || !reportDrawerFilterData?.projectId?.length) return;
        const selected = filteredProjects.filter((project) =>
            reportDrawerFilterData.projectId.some(
                (p) => p?.value == project.value || p == project.value
            )
        );

        setSelectedProjects(selected);
    }, [filteredProjects, reportDrawerFilterData?.projectId]);


    useEffect(() => {
        fetchProjects()
    }, [])

    const debouncedSearch = useCallback(
        debounce((value) => {
            setSearchValue(value)
        }, 600),
        []
    )

    const handleProjectChange = (selected) => {
        setSelectedProjects(selected)

        const updatedFilter = {
            ...reportDrawerFilterData,
            projectId: selected,
        }

        dispatch(setDrawerFilter(updatedFilter))
    }

    const tagRender = ({ label, value, closable, onClose }) => {
        const matched = filteredProjects.find((p) => p.value === value);
        const initials = label
            ?.split(' ')
            .map((w) => w[0]?.toUpperCase())
            .join('');

        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '2px 6px',
                    background: '#f0f0f0',
                    borderRadius: '999px',
                    marginRight: 4,
                }}
            >
                {matched?.projectProfile ? (
                    <Image
                        src={matched.projectProfile}
                        width={18}
                        height={18}
                        preview={false}
                        style={{ borderRadius: '50%', marginRight: 6 }}
                    />
                ) : (
                    <Avatar
                        size={18}
                        style={{
                            fontSize: 10,
                            backgroundColor: '#ccc',
                            marginRight: 6,
                        }}
                    >
                        {initials}
                    </Avatar>
                )}
                <span style={{ fontSize: 12, marginRight: 6 }}>{label}</span>
                {closable && (
                    <span onClick={onClose} style={{ cursor: 'pointer' }}>
                        ✕
                    </span>
                )}
            </div>
        );
    };


    return (
        <div>
            <Row
                align="middle"
                style={{ columnGap: '20px', flexFlow: 'nowrap', width: '100%' }}
            >
                <InfiniteScrollSelect
                    mode="multiple"
                    style={{ minWidth: '250px' }}
                    className="reports_user_selecter reports_user_selecter"
                    rootClassName="p-0-multiSelect"
                    value={selectedProjects}
                    onChange={handleProjectChange}
                    onOpen={fetchProjects}
                    placeholder="Select Projects"
                    data={filteredProjects}
                    isNext={false}
                    loading={false}
                    currentPage={1}
                    search={searchValue}
                    fetchMore={() => { }}
                    onSearch={(val) => {
                        setSearchValue(val)
                        debouncedSearch(val)
                    }}
                    tagRender={(props) => {
                        const { label, value, closable, onClose } = props
                        const matched = filteredProjects.find((p) => p.value === value)

                        return (

                            <div style={styles.tag}>
                                {matched?.profilePicture ? (
                                    <Avatar size={25} src={matched.profilePicture} style={{ marginRight: 6 }} />
                                ) : (
                                    <Avatar size={25} style={styles.avatarFallback}>
                                        {label?.[0]}
                                    </Avatar>
                                )}
                                <span style={styles.label}>{label}</span>
                                {closable && (
                                    <span
                                        onClick={onClose}
                                        style={{ cursor: 'pointer', display: 'flex' }}
                                    >
                                        <CrossIcon width={10} color={'#252525'} />
                                    </span>
                                )}
                            </div>
                            // <div
                            //     style={{
                            //         display: 'flex',
                            //         alignItems: 'center',
                            //         padding: '2px 6px',
                            //         background: '#f0f0f0',
                            //         borderRadius: '999px',
                            //         marginRight: 4,
                            //     }}
                            // >
                            //     {matched?.projectProfile ? (
                            //         <Image
                            //             src={matched.projectProfile}
                            //             width={18}
                            //             height={18}
                            //             preview={false}
                            //             style={{ borderRadius: '50%', marginRight: 6 }}
                            //         />
                            //     ) : (
                            //         <Avatar size={18} style={{ marginRight: 6 }}>
                            //             {label?.[0]}
                            //         </Avatar>
                            //     )}
                            //     <span style={{ fontSize: 12, marginRight: 6 }}>{label}</span>
                            //     {closable && (
                            //         <span
                            //             style={{ cursor: 'pointer' }}
                            //             onClick={onClose}
                            //         >
                            //             ✕
                            //         </span>
                            //     )}
                            // </div>
                        )
                    }}
                    renderOption={({ projectProfile, label }) => (
                        <Space>
                            {projectProfile ? (
                                <Image
                                    src={projectProfile}
                                    width={24}
                                    height={24}
                                    preview={false}
                                    style={{ borderRadius: '50%' }}
                                />
                            ) : (
                                <Avatar size={24}>{label?.[0]}</Avatar>
                            )}
                            <span>{label}</span>
                        </Space>
                    )}
                />
                <UserReportDrawerDateFilter />
            </Row>
        </div>
    )
}
const styles = {
    tag: {
        display: 'flex',
        alignItems: 'center',
        background: '#f5f5f5',
        borderRadius: 10,
        padding: '4px 8px 4px 4px',
        margin: '4px 2px',
        maxWidth: '100%',
        border: '1px solid #afafaf80',
    },
    avatarFallback: {
        backgroundColor: 'rgb(0 10 129 / 25%)',
        color: '#000',
        fontSize: 10,
        marginRight: 6,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 25,
        height: 25,
    },
    label: {
        fontSize: 14,
        fontWeight: 500,
        color: '#333',
        marginRight: 4,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: 100,
    },
}

export default UserReportsDrawerFilter
